<template>
  <div>
    <div class="text-right mb-3">
      <image-uploader
        :className="'invisible'"
        :preview="false"
        :autoRotate="true"
        :maxWidth="1200"
        :quality="0.7"
        :capture="false"
        outputFormat="verbose"
        @input="uiUpload"
      >
        <label for="fileInput" slot="upload-label">
          <span class="btn btn-primary">Upload</span>
        </label>
      </image-uploader>
    </div>
    <div class="d-flex flex-wrap">
      <div
        v-for="image in images"
        v-bind:key="image['.key']"
        class="card"
        style="width: 25rem;"
      >
        <div class="hovereffect">
          <img
            v-bind:src="'data:image/png;base64, ' + image.value"
            v-bind:alt="image.date"
            class="img-fluid"
          />
          <div class="overlay">
            <h2>{{ dateformat(image.date, "ddd, mmm d") }}</h2>
            <a
              class="info"
              href=""
              @click.prevent
              v-on:click="uiHide(image['.key'])"
              >Hide</a
            >
            <br />
            <a class="info" href="" @click.prevent v-on:click="uiOpen(image)"
              >Open</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "./main";
import dateformat from "dateformat";
import md5 from "md5";

export default {
  name: "Images",
  data() {
    return {
      images: []
    };
  },
  firestore() {
    return {
      images: db
        ? db
            .collection("images")
            .where("hide", "==", false)
            .orderBy("date", "desc")
            .limit(20)
        : []
    };
  },
  methods: {
    dateformat,
    uiHide: function(key) {
      db.collection("images")
        .doc(key)
        .set({ hide: true }, { merge: true });
    },
    uiOpen: function(image) {
      const popup = window.open();
      popup.document.write(
        '<img src="data:image/png;base64, ' + image.value + '">'
      );
    },
    uiUpload: function(upload) {
      const start = upload.dataUrl.search(",") + 1;
      const value = upload.dataUrl.substring(start);
      const key = md5(value);
      const date = dateformat(new Date(), "isoDateTime");
      db.collection("images")
        .doc(key)
        .set({ value, date, hide: false });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.hovereffect {
  width: 100%;
  height: 100%;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
}

.hovereffect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
}

.hovereffect img {
  display: block;
  position: relative;
  -webkit-transition: all 0.4s ease-in;
  transition: all 0.4s ease-in;
}

.hovereffect:hover img {
  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="filter"><feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0" /><feGaussianBlur stdDeviation="3" /></filter></svg>#filter');
  filter: grayscale(1) blur(3px);
  -webkit-filter: grayscale(1) blur(3px);
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}

.hovereffect h2 {
  text-transform: uppercase;
  text-align: center;
  position: relative;
  font-size: 17px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.6);
}

.hovereffect a.info {
  display: inline-block;
  text-decoration: none;
  padding: 7px 14px;
  border: 1px solid #fff;
  margin: 50px 0 0 0;
  background-color: transparent;
}

.hovereffect a.info:hover {
  box-shadow: 0 0 5px #fff;
}

.hovereffect a.info,
.hovereffect h2 {
  -webkit-transform: scale(0.7);
  -ms-transform: scale(0.7);
  transform: scale(0.7);
  -webkit-transition: all 0.4s ease-in;
  transition: all 0.4s ease-in;
  opacity: 0;
  filter: alpha(opacity=0);
  color: #fff;
  text-transform: uppercase;
}

.hovereffect:hover a.info,
.hovereffect:hover h2 {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}
</style>
